(function () {
  'use strict';

  var carousels = document.querySelectorAll('[data-vzc-carousel]');
  if (!carousels.length) return;

  carousels.forEach(function (root) {
    var track = root.querySelector('[data-vzc-track]');
    var viewport = root.querySelector('[data-vzc-viewport]');
    var prevBtn = root.querySelector('[data-vzc-prev]');
    var nextBtn = root.querySelector('[data-vzc-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-vzc-dot]'));
    var count = parseInt(root.getAttribute('data-count'), 10) || 0;
    if (!track || !count) return;
    if (root.__vzcInitialized) return; // theme editor can re-run this script on section reload
    root.__vzcInitialized = true;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var AUTOPLAY_MS = 6000;
    // Track layout: [clone-last, slide-0, slide-1, ..., slide-N-1, clone-first]
    var pos = 1; // current track index (1..count map to real slides 0..count-1)
    var timer = null;
    var isTransitioning = false;

    function realIndex(p) {
      return ((p - 1) + count) % count;
    }

    function updateDots() {
      var ri = realIndex(pos);
      dots.forEach(function (d, i) {
        var active = i === ri;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function render(withTransition) {
      var instant = !withTransition || reduceMotion;
      if (instant) {
        track.classList.add('vzc-no-transition');
      } else {
        track.classList.remove('vzc-no-transition');
      }
      track.style.transform = 'translateX(-' + (pos * 100) + '%)';
      updateDots();
      return instant;
    }

    function settleClones() {
      if (pos === 0) {
        pos = count;
        render(false);
      } else if (pos === count + 1) {
        pos = 1;
        render(false);
      }
    }

    function goTo(p, withTransition) {
      if (isTransitioning) return;
      pos = p;
      isTransitioning = true;
      var instant = render(withTransition !== false);
      // With no CSS transition running (reduced-motion, or an explicit
      // instant jump) `transitionend` never fires, so settle synchronously
      // here instead of waiting for an event that won't come — otherwise
      // isTransitioning gets stuck true and the carousel stops responding.
      if (instant) {
        settleClones();
        isTransitioning = false;
      }
    }

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track) return;
      isTransitioning = false;
      settleClones();
    });

    function next() { goTo(pos + 1); }
    function prev() { goTo(pos - 1); }
    function goToReal(ri) { goTo(ri + 1); }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function startAutoplay() {
      if (reduceMotion) return;
      stopAutoplay();
      timer = setInterval(function () {
        if (!document.hidden) next();
      }, AUTOPLAY_MS);
    }
    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { prev(); restartAutoplay(); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { next(); restartAutoplay(); });
    }
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goToReal(i); restartAutoplay(); });
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); restartAutoplay(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); next(); restartAutoplay(); }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    // Touch swipe: horizontal-dominant drags only, so vertical page scroll
    // is never hijacked. A drag beyond the threshold also suppresses the
    // synthetic click on release so it doesn't accidentally navigate.
    var touchStartX = 0, touchStartY = 0, dragging = false, dragged = false;
    var SWIPE_THRESHOLD = 40;

    viewport.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      touchStartX = t.clientX;
      touchStartY = t.clientY;
      dragging = true;
      dragged = false;
    }, { passive: true });

    viewport.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var t = e.touches[0];
      var dx = t.clientX - touchStartX;
      var dy = t.clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
        dragged = true;
        if (e.cancelable) e.preventDefault();
      }
    }, { passive: false });

    viewport.addEventListener('touchend', function (e) {
      if (!dragging) return;
      dragging = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - touchStartX;
      var dy = t.clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > SWIPE_THRESHOLD) {
        if (dx < 0) next(); else prev();
        restartAutoplay();
      }
    });

    // Suppress the click that follows a horizontal drag release, capture phase.
    root.addEventListener('click', function (e) {
      if (dragged) {
        e.preventDefault();
        e.stopPropagation();
        dragged = false;
      }
    }, true);

    render(false);
    startAutoplay();
  });
})();
